export default theme => ({
    finalizeContainer: {
        marginTop: theme.spacing.unit * 6,
        fontSize: 18,
    },

    finalize: {
        color: theme.palette.primary.main,

        '@media print': {
            display: 'none'
        }
    }
})
